// Variants des sections
import {
  HeroDefault,
  HeroSplit,
  HeroSplitInverse,
  HeroMinimal,
  HeroInfo,
  HeroInfoInverse,
  HeroCarousel,
  HeroWithFilters,
  HeroRowWithSS,
  HeroAds,
  HeroVideo,
} from "../components/sections/HeroVariants";
import {
  GridColumns,
  GridIcons,
  GridCards,
  GridSplit,
  GridSplitDark,
  GridSections,
  TwoCardsGrid,
  CategoryGrid,
  LatestProductsGrid,
  GridThreeIcon,
  GridActus,
  GridWithoutTitle,
} from "../components/sections/GridVariants";
import { FaqAccordion, FaqList } from "../components/sections/FaqVariants";
import {
  CtaAppDownload,
  CtaCentered,
  CtaContact,
  CtaNewsletter,
  CtaSplit,
} from "../components/sections/CallToActionVariants";
import CarouselDetails, {
  CarouselSimple,
  CarouselWithCaptions,
  CarouselYTB,
  CarouselProduits,
} from "../components/sections/CarouelsVariants";
import {
  TwoColsImageGrid,
  TwoColsWithInlineSS,
  TwoColsWithoutSS,
  TwoColsWithoutSSInverse,
  TwoColsWithSS,
} from "../components/sections/TwoCols";

// Fonction d'affichage selon le type + variant
export function RenderSection(section) {
  const { type, variant, id } = section;

  const map = {
    hero: {
      default: HeroDefault,
      split: HeroSplit,
      ads: HeroAds,
      "split-inverse": HeroSplitInverse,
      minimal: HeroMinimal,
      "carousel-with-nav": HeroCarousel,
      info: HeroInfo,
      video: HeroVideo,
      "info-inverse": HeroInfoInverse,
      "with-filters": HeroWithFilters,
      "row-with-ss": HeroRowWithSS,
    },
    grid: {
      columns: GridColumns,
      icons: GridIcons,
      cards: GridCards,
      "three-icons": GridThreeIcon,
      split: GridSplit,
      "split-dark": GridSplitDark,
      sections: GridSections,
      "two-cards": TwoCardsGrid,
      "latest-products": LatestProductsGrid,
      categories: CategoryGrid,
      actus: GridActus,
      "without-title": GridWithoutTitle,
    },
    calltoaction: {
      centered: CtaCentered,
      split: CtaSplit,
      app: CtaAppDownload,
      newsletter: CtaNewsletter,
      contact: CtaContact,
    },
    carousel: {
      simple: CarouselSimple,
      link: CarouselYTB,
      details: CarouselDetails,
      "with-captions": CarouselWithCaptions,
      "with-produits": CarouselProduits,
    },
    faq: {
      accordion: FaqAccordion,
      list: FaqList,
    },
    "2-col": {
      "with-ss": TwoColsWithSS,
      "without-ss": TwoColsWithoutSS,
      "without-ss-inverse": TwoColsWithoutSSInverse,
      "with-inline-ss": TwoColsWithInlineSS,
      image: TwoColsImageGrid,
    },
  };

  const Component = map[type]?.[variant];
  return Component ? <Component key={id} section={section} /> : null;
}
